import { render, staticRenderFns } from "./ngo-faq.vue?vue&type=template&id=481caed6&"
import script from "./ngo-faq.vue?vue&type=script&lang=js&"
export * from "./ngo-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports